import React, { useState } from "react";
import Swal from "sweetalert2";
import { Form, Typography } from "antd";
import { LoginWrapper } from "./style";
import loginImage from "../../assets/images/login-1.png";
import loginLogo from '../../assets/images/newlog.svg';
import { customBaseUrl, httpPost } from "../../store/http";
import { hideLoader, showLoader } from "../../utils/loader";
import PinModal from "../../components/Modal/Pin/PinModal";
import GlassCard from "../../components/premium/GlassCard";
import PremiumButton from "../../components/premium/PremiumButton";
import PremiumInput from "../../components/premium/PremiumInput";

const { Title, Text } = Typography;

export default function ApproverLogin() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState('');

  const handleContinue = async (values) => {
    const loginData = values || data;
    showLoader();
    setLoading(true);

    try {
      const res = await httpPost(`${customBaseUrl.loanUrl}/api/v1/approver/approver-verify`, {
        emailAddress: loginData.username || loginData.emailOrPhoneNumber,
        password: loginData.password,
      });

      hideLoader();
      setLoading(false);

      if (res.status) {
        localStorage.setItem("email", loginData.username || loginData.emailOrPhoneNumber);
        localStorage.setItem("approverRole", res.data.role);
        window.location.href = "/loan";
      } else {
        Swal.fire("Error", res.message, "error");
        if (res.message === "Account not Verified") {
          setTimeout(() => {
            window.location.href = `/activate_account?emailOrPhone=${loginData.username || loginData.emailOrPhoneNumber}`;
            sessionStorage.setItem("activation_request_trials", "6B86B273FF34FCE19D6B804EFF5A3F5747ADA4EAA22F1D49C01E52DDB7875B4B");
          }, 3000);
        }
      }
    } catch (error) {
      hideLoader();
      setLoading(false);
      Swal.fire("Error", "Something went wrong.", "error");
    }
  };

  const onFinish = async (values) => {
    setData({ emailOrPhoneNumber: values.username, password: values.password });
    setLoading(true);
    showLoader();
  
    try {
      const res = await httpPost(`${customBaseUrl.authUrl}/api/v1/auth/generate-login-otp?email=${values.username}`);
      hideLoader();      
      setLoading(false);

      if (res.status) {
        setShowOtp(true);
      } else {
        if (res?.message === " 2FA not active for this user") {
          handleContinue(values);
        } else {
          Swal.fire("Error", res.message, "error");
        }
      }
    } catch (error) {
      hideLoader();
      setLoading(false);
      Swal.fire("Error", "Unable to proceed.", "error");
    }
  };

  return (
    <LoginWrapper>
      <div className="auth-container">
        <div className="auth-info">
          <div className="logo-container">
            <img src={loginLogo} alt="WayaBank Logo" />
          </div>
          <h1>WayaBank <br />Approver Console.</h1>
          <p>Secure verification and approval management system.</p>
          <img src={loginImage} alt="Approver Illustration" style={{ marginTop: '40px', width: '80%', maxWidth: '400px' }} />
        </div>

        <div className="auth-form-section">
          <GlassCard padding="48px" radius="24px">
            <Title level={2} style={{ marginBottom: '8px', fontWeight: 600 }}>Approver Login</Title>
            <Text type="secondary" style={{ display: 'block', marginBottom: '32px' }}>
              Access the approval management system
            </Text>

            <Form layout="vertical" onFinish={onFinish} autoComplete="off">
              <Form.Item label="Approver Email" name="username" rules={[{ required: true, message: 'Required' }]}>
                <PremiumInput placeholder="approver@wayabank.com" />
              </Form.Item>

              <Form.Item label="Password" name="password" rules={[{ required: true, message: 'Required' }]}>
                <PremiumInput.Password placeholder="••••••••" />
              </Form.Item>

              <Form.Item style={{ marginTop: '32px' }}>
                <PremiumButton type="primary" htmlType="submit" loading={loading} block style={{ height: '48px' }}>
                  Sign in
                </PremiumButton>
              </Form.Item>
            </Form>
          </GlassCard>
        </div>
      </div>

      {showOtp && (
        <PinModal
          showModal={showOtp}
          hideModal={setShowOtp}
          otp={otp}
          setOtp={setOtp}
          title="2FA Verification"
          description="Enter the 6-digit code sent to your device"
          buttonLabel="Verify"
          handleSubmit={() => handleContinue()}
          numInputs={6}
          pinMode={true}
        />
      )}
    </LoginWrapper>
  );
}
